import { render } from "./arrowSvg.vue?vue&type=template&id=8798e9d2"
import script from "./arrowSvg.vue?vue&type=script&lang=js"
export * from "./arrowSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__